import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { fadeIn, staggerContainer } from './utils/animations';

const Terms = () => {
  useEffect(() => {
    document.title = "Terms of Service | forca.dev";
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div
      variants={staggerContainer(0.1, 0.1)}
      initial="hidden"
      animate="show"
      className="pt-24 pb-16 px-4"
    >
      <div className="container mx-auto max-w-4xl">
        <motion.h1 
          variants={fadeIn('down', 0.2)}
          className="text-3xl md:text-4xl font-bold text-white mb-8 text-center"
        >
          Terms of Service
        </motion.h1>

        <motion.div
          variants={fadeIn('up', 0.3)}
          className="prose prose-invert prose-slate max-w-none"
        >
          <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 md:p-8 shadow-xl">
            <p className="text-slate-300">Last Updated: May 7, 2025</p>

            <h2>1. Agreement to Terms</h2>
            <p>
              By accessing or using our services, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access our services.
            </p>

            <h2>2. Description of Services</h2>
            <p>
              forca.dev provides web development and digital services including but not limited to custom website design, SEO optimization, and online presence management.
            </p>

            <h2>3. Intellectual Property</h2>
            <p>
              The content, features, and functionality of our website, including but not limited to text, graphics, logos, and code, are owned by forca.dev and are protected by copyright, trademark, and other intellectual property laws.
            </p>

            <h2>4. User Responsibilities</h2>
            <p>
              When using our services, you agree to:
            </p>
            <ul>
              <li>Provide accurate information</li>
              <li>Maintain the security of your account</li>
              <li>Use our services only for lawful purposes</li>
              <li>Not infringe on the intellectual property rights of others</li>
            </ul>

            <h2>5. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, forca.dev shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use our services.
            </p>

            <h2>6. Termination</h2>
            <p>
              We may terminate or suspend your access to our services immediately, without prior notice or liability, for any reason whatsoever, including if you breach these Terms of Service.
            </p>

            <h2>7. Changes to Terms</h2>
            <p>
              We reserve the right to modify or replace these Terms of Service at any time. By continuing to access or use our services after any revisions become effective, you agree to be bound by the revised terms.
            </p>

            <h2>8. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which forca.dev operates, without regard to its conflict of law provisions.
            </p>

            <h2>9. Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us at:
            </p>
            <p className="text-cyan-400">info@forca.dev</p>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Terms;